module.exports = __webpack_public_path__ + "img/abc9e99.png";